import Vue from "vue"
Vue.mixin({
  data() {
    return {
      // 缓存的key
      cache_dict_sort: 'cache_dict_sort',   // key: 缓存字典分类
      cache_dict_detail: 'cache_dict_detail',   // key: 缓存字典数据
      cache_legal_contract_params: 'cache_legal_contract_params', // 缓存法务管理法律列表页面用到的参数
    }
  },
  methods: {
    $setCache(key, value) {
      let md5Key = this.$md5(key)
      let encodeValue = Base64.encode(JSON.stringify(value))
      window.localStorage.setItem(md5Key, encodeValue)
    },

    $getCache(key) {
      let md5Key = this.$md5(key)
      let decodeValue = Base64.decode(window.localStorage.getItem(md5Key))
      return JSON.parse(decodeValue);
    }
  }

})



// WEBPACK FOOTER //
// ./src/mixin/cache.js